<div class="image-editor-container">
  <div class="image-editor-body">
    <section class="image-editor-parent">
      <div class="image-specifications">
        <div>
          <div class="text-muted">{{ 'SHARED.DIMENSIONS' | translate }}</div>
          <div>
            <ng-container *ngIf="croppedImageProps.width; else inputDimensions">
              {{ croppedImageProps.width }} X {{ croppedImageProps.height }}
              {{ croppedImageProps.unit }}
            </ng-container>
            <ng-template #inputDimensions>
              {{ imageProps.imageDimensions }}
            </ng-template>
          </div>
        </div>
        <div>
          <div class="text-muted">{{ 'SHARED.FORMAT' | translate }}</div>
          <div>{{ 'SHARED.IMAGE_FORMAT' | translate }}</div>
        </div>
        <div>
          <div class="text-muted">{{ 'SHARED.SIZE' | translate }}</div>
          <div>{{ maxUploadSizeInMB }} MB</div>
        </div>
      </div>
      <div class="main-image-area">
        <div class="placeholder-area" *ngIf="!imageAvailable">
          <div class="drag-drop-upload" (dragover)="handleDragOver($event)">
            <input
              type="file"
              (change)="fileChangeEvent($event)"
              accept="image/png, image/jpeg"
              #imgUpload
              class="drop-image-zone"
            />
            <div>
              <div>{{ 'SHARED.DRAG_DROP' | translate }}</div>
              <button class="upload-file" (click)="browseFile()">
                {{ 'SHARED.UPLOAD_FILE' | translate }}
              </button>
            </div>
          </div>
          <div class="info" *ngIf="!inputError">
            <i class="fa fa-info-circle"></i>&nbsp;{{
              !data?.file
                ? ('SHARED.ADDING_IMAGES_FOR_DISH' | translate)
                : ('SHARED.ADDING_IMAGES_FOR_LOGO' | translate)
            }}
          </div>
        </div>
        <div class="image-parent-container height-0-{{ !imageAvailable }}">
          <image-cropper
            [imageChangedEvent]="imageChangedEvent"
            [maintainAspectRatio]="false"
            [aspectRatio]="imageProps.aspectRatio"
            [format]="file_type"
            (imageCropped)="imageCropped($event)"
            (imageLoaded)="imageLoaded($event)"
            (cropperReady)="cropperReady()"
            [canvasRotation]="canvasRotationValue"
            [transform]="transform"
            [containWithinAspectRatio]="containWithinAspectRatio"
            [resizeToWidth]="1920"
            [resizeToHeight]="1080"
          ></image-cropper>
        </div>
        <div class="error-message">{{ inputError }}</div>
      </div>
      <div class="image-editor-actions" *ngIf="imageAvailable">
        <div>
          <button
            (click)="zoomCanvas('+')"
            class="btn-disabled-{{ enableZoomRestriction && zoomCount === 2 }}"
          >
            <i class="fa fa-plus-circle fa-lg"></i>
          </button>
          &nbsp;<strong>{{ 'SHARED.ZOOM' | translate }}</strong
          >&nbsp;
          <button
            (click)="zoomCanvas('-')"
            class="btn-disabled-{{ enableZoomRestriction && zoomCount === 0 }}"
          >
            <i class="fa fa-minus-circle fa-lg"></i>
          </button>
        </div>
        <div>
          <button (click)="rotateCanvas('left')">
            <img
              [src]="images.ROTATE"
              alt="rotate-icon"
              class="rotate-canvas"
            />&nbsp;<strong>{{ 'SHARED.ROTATE' | translate }}</strong>
          </button>
        </div>
      </div>
    </section>
    <section class="image-editor-guidelines">
      <strong>{{ 'SHARED.IMG_GUIDE' | translate }}</strong>
      <section>
        <div
          class="guideline-list-item"
          *ngFor="let guideline of imageGuidelines"
        >
          <div class="guideline-image">
            <img [src]="guideline.img" alt="image-guideline" />
          </div>
          <div class="guideline">
            <i
              class="fa fa-{{
                guideline.check ? 'check' : 'times'
              }}-circle fa-2x"
            ></i>
            <div>{{ guideline.text }}</div>
          </div>
        </div>
      </section>
    </section>
  </div>
  <div class="image-editor-footer">
    <button
      class="upload"
      [disabled]="!imageAvailable || !croppedImageMeetsMinimumDimensions"
      (click)="uploadImage()"
    >
      {{ 'SHARED.UPLOAD' | translate }}
    </button>
  </div>
</div>
<img
  *ngIf="imgSrc"
  class="preview-container-il"
  [src]="imgSrc"
  (load)="previewImgLoaded($event)"
  #imgPreview
  alt="img-preview"
/>
